import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";

const FooterSmall = (props) => {
	const [isUs, setIsUs] = useState(false);
	useEffect(() => {
		const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
		const isTheUS = tz.split("/")[0] === "America";
		setIsUs(isTheUS);
	}, []);

	return (
		<div className=" footer__container--small-outer">
			<footer className="footer__container footer__container--small mt-auto py-2">
				<Row
					className="footer__content flex-column width_ctrl justify-content-center"
					nogutters="true"
				>
					<Col
						className=" footer__copyright d-flex justify-content-center align-items-center"
						style={{ color: "#999" }}
					>
						<a
							href="https://netflix.com"
							rel="noopener noreferrer"
							target="_blank"
						>
							Netflix.com
						</a>
						<span className="text-white-50">
							&nbsp;&nbsp;|&nbsp;&nbsp;
						</span>
						{window.Optanon ? (
							<>
								<a
									href="/"
									onClick={(e) => {
										e.preventDefault();
										if (window.Optanon) {
											window.Optanon.ToggleInfoDisplay();
										}
										return false;
									}}
								>
									Cookie Preferences
								</a>
							</>
						) : (
							<></>
						)}
						{isUs ? (
							<>
								<span className="text-white-50">
									&nbsp;&nbsp;|&nbsp;&nbsp;
								</span>
								<a href="/do-not-sell-or-share">
									Do Not Sell or Share My Personal Information
								</a>
							</>
						) : (
							<></>
						)}
					</Col>
					<Col
						className=" footer__copyright d-flex justify-content-center align-items-center  mt-1"
						style={{ color: "#999" }}
					>
						<p>
							All uses of the Netflix For Your Consideration
							Website are subject to the terms of use associated
							with your promotional code and the{" "}
							<a href="/privacy-and-terms">Privacy and Terms</a>
						</p>
					</Col>
				</Row>
			</footer>
		</div>
	);
};

export default FooterSmall;
